import { render, staticRenderFns } from "./GYModal.vue?vue&type=template&id=0c33f3b7&scoped=true"
import script from "./GYModal.vue?vue&type=script&lang=js"
export * from "./GYModal.vue?vue&type=script&lang=js"
import style0 from "./GYModal.vue?vue&type=style&index=0&id=0c33f3b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c33f3b7",
  null
  
)

export default component.exports